import { useMainContext } from "../context";
import { useLanguageContext } from "../context/languageContext";
import { useMainQuery } from "../hooks/useMainQuery";
import success from "./../assets/images/success.svg";
import { languageEN } from "./../languageEN";
import { languagePL } from "./../languagePL";
import { Button } from "./primitives";

export const SuccessAnnouncement = () => {
  const { form } = useMainContext();
  const { data } = useMainQuery();
 
  const { language, setLanguage } = useLanguageContext();
  const emailHandler = () => {
    let marian;
    Object.values(form).map((value) => {
      if (value.type === "form") {
        Object.values(value.value).map((insideValue) => {
          if (insideValue.validation.type === "email") {
            marian = insideValue.value;
            return insideValue.value;
          }
        });
      }
    });
    return marian;
  };

  return (
    <div className="successContainer">
      <div className="successHeadingContainer">
        <img className="successImg" src={success} alt="" />
        <p className="successHeading">
          {language === "PL" ? languagePL.sucessTitle : languageEN.sucessTitle}
        </p>
      </div>
      <div className="successContent">
        <p className="successContext">
          {language === "PL"
            ? languagePL.successDesc + `${emailHandler()}`
            : languageEN.successDesc + `${emailHandler()}`}
        </p>
      </div>
      <Button
        type="homepage"
        onClick={() => window.location.assign(data?.data.returnUrl!)}
      />
    </div>
  );
};
